import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import EventStartDatePicker from "components/EventStartDatePicker";
import EventEndDatePicker from "components/EventEndDatePicker";
import {
  FormControl,
  Grid,
  InputLabel,
} from "@mui/material";
import { CourseFilter } from "services/facultyPortalClient";
import { CommonFilter, useIsFilterApplied } from "@knowfully/ui.common";

const styles = {
  label: {
    transform: "translate(0, -1.5rem) scale(1)",
    fontSize: 12,
  },
};

type CoursesFilterProps = {
  onChange: (filter: CourseFilter) => void;
};

export default function CoursesFilter({ onChange }: CoursesFilterProps) {
  const { formatMessage: t } = useIntl();
  const [filter, setFilter] = useState({ searchText: "" } as CourseFilter);

  const isFilterApplied = useIsFilterApplied(filter, []);

  const onChangeInternal = (prop: keyof CourseFilter, val: any) => {
    setFilter((prev) => ({ ...prev, [prop]: val }) as CourseFilter);
  };

  // Auto-apply filters to parent on any change
  useEffect(() => {
    onChange(filter);
  }, [filter, onChange]);

  const clearFilter = () => {
    const emptyFilter = { searchText: "" } as CourseFilter;
    setFilter(emptyFilter);
    onChange(emptyFilter);
  };

  return (
    <CommonFilter
      searchText={filter.searchText}
      onSearchTextChange={(val) => onChangeInternal("searchText", val)}
      onClear={clearFilter}
      isFilterApplied={isFilterApplied}
    >
      <Grid item xs={12} sm={12} md={12} />
      <Grid item xs={12} sm={12} md={6}>
        <FormControl variant="outlined" size="small" fullWidth>
          <InputLabel shrink sx={styles.label}>
            {t({ id: "courseDate" })}
          </InputLabel>

          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={6}>
              <EventStartDatePicker
                value={filter.eventStartDate}
                onChange={(value: Date | undefined) =>
                  onChangeInternal("eventStartDate", value)
                }
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <EventEndDatePicker
                value={filter.eventEndDate}
                onChange={(value: Date | undefined) =>
                  onChangeInternal("eventEndDate", value)
                }
              />
            </Grid>
          </Grid>
        </FormControl>
      </Grid>
    </CommonFilter>
  );
}
